import { CSSProperties, PropsWithChildren } from "react";

type Props = PropsWithChildren<object>;

export default function TBody({ children }: Props) {
  const styles: CSSProperties = {
    backgroundColor: "var(--color-background-overlay)",
    border: "1px solid var(--color-border-primary)",
  };

  return <tbody style={styles}>{children}</tbody>;
}
